<template>
  <div>
    <page-header
      title="Approval"
      :back="{path: '/3pl/dashboard' }"
      breadcrumb="Dashboard > Settings > Approval"
    />
    <div class="custom-card">
      <div class="flex flex-row my-2 justify-between">
        <span class="col-md-10 text-sm"
          >Set up approval flows for sensitive actions or privileges. The
          approval process can be automatic or manual depending on your
          preferences</span
        >
        <base-button @click="createWorkFlow" text="New Worklow"></base-button>
      </div>
      <div class="col-12">
        <span class="text-base font-semibold">Modules and Actions/Forms</span>
      </div>
      <div>
        <Accordion title="">
          <accordion-item
            class="modules"
            :title="item.title"
            v-for="(item, i) in accItem"
            :key="i"
          >
            <div class="border rounded-md p-3 border-blue-200 my-2">
              <div class="text-sm">
                <span
                  >These action or forms/documents have been profiled for
                  approval. You can edit their approval flows, or remove them
                  entirely from requiring approval upon initiation/submission.
                  Switch between sub modules to see profiles actions</span
                >
              </div>
              <div>
                <MTab
                  :tabs="tabs"
                  :currentTab="currentTab"
                  @current-tab="currentTab = $event"
                />
              </div>
              <div class="my-3">
                <tab-item></tab-item>
              </div>
            </div>
          </accordion-item>
        </Accordion>
      </div>
    </div>
  </div>
</template>

<script>
import Accordion from "./partials/Accordion.vue";
import PageHeader from "@/components/UI/NewPageHeader";

import AccordionItem from "./partials/AccordionItem.vue";
import TabItem from "./partials/TabItem.vue";
// import PrivilegesDataTable from "./Privileges/PrivilegesDataTable";
// import FormsDataTable from "./Forms/FormsDataTable";
import MTab from "./partials/MTab.vue";
export default {
  components: {
    Accordion,
    AccordionItem,
    MTab,
    TabItem,
    PageHeader
    // PrivilegesDataTable,
    // FormsDataTable,
    // ApprovalFlowModal,
  },
  data() {
    return {
      isApprovalModal: false,
      accItem: [
        {
          title: "title",
          content: "lorem impusnt  diuhwnfwef hiuwfnwed iuhadggd iuh",
        },
        {
          title: "title",
          content: "lorem impusnt  diuhwnfwef hiuwfnwed iuhadggd iuh",
        },
        {
          title: "title",
          content: "lorem impusnt  diuhwnfwef hiuwfnwed iuhadggd iuh",
        },
        {
          title: "title",
          content: "lorem impusnt  diuhwnfwef hiuwfnwed iuhadggd iuh",
        },
        {
          title: "title",
          content: "lorem impusnt  diuhwnfwef hiuwfnwed iuhadggd iuh",
        },
        {
          title: "title",
          content: "lorem impusnt  diuhwnfwef hiuwfnwed iuhadggd iuh",
        },
      ],
      tabs: [
        {
          value: "Functional Hierachy",
          id: "functionalHierachy",
        },
        {
          value: "Job Level",
          id: "jobLevel",
        },
        {
          value: "Designation",
          id: "designation",
        },
        {
          value: "People",
          id: "people",
        },
      ],
      currentTab: "functionalHierachy",
    };
  },
  methods:{
    createWorkFlow(){
      this.$router.push({name:'createApprovalWorkFlow'})
    }
  }
};
</script>

<style scoped>
.modules:nth-child(even) {
  background-color: #dae8f6;
}
</style>
